import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

function unwrapList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.$values)) return data.$values;
  return [];
}

const SubscriptionService = {

  createSubscription: async (subscriptionData) => {
    try {
      const response = await axios.post(`${API_URL}/Subscription/CreateSubscription/`, subscriptionData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getSubscriptionById: async (id) => {
    try {
      const response = await axios.get(`${API_URL}/Subscription/GetSubscriptionById/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

    getSubscriptionsByClientId: async (clientId) => {
      try {
        const response = await axios.get(`${API_URL}/Subscription/GetSubscriptionsByClientId/${clientId}`);
        return unwrapList(response.data);
      } catch (error) {
        console.error(`Error fetching subscriptions for client ${clientId}: `, error);
        throw error;
      }
    },

    getClientSubscriptionStatus: async (clientId) => {
      try {
        const response = await axios.get(`${API_URL}/Subscription/GetClientSubscriptionStatus/${clientId}`);
        return response.data ?? {};
      } catch (error) {
        console.error(`Error fetching subscription status for client ${clientId}: `, error);
        throw error;
      }
    },

      patchSubscription: async (id, payload) => {
        try {
          const response = await axios.patch(`${API_URL}/Subscription/PatchSubscription/${id}`, payload);
          return response.data;
        } catch (error) {
          throw error;
        }
      },

      updateSubscription: async (id, subscriptionData) => {
        try {
          const response = await axios.put(`${API_URL}/Subscription/UpdateSubscription/${id}`, subscriptionData);
          return response.data;
        } catch (error) {
          throw error;
        }
      },

      deleteSubscription: async (id) => {
        try {
          await axios.delete(`${API_URL}/Subscription/DeleteSubscription/${id}`);
        } catch (error) {
          throw error;
        }
      },

      getAllSubscriptionPlans: async () => {
        try { 
          const response = await axios.get(`${API_URL}/SubscriptionPlan/GetAllSubscriptionPlans`);
          return unwrapList(response.data);
        } catch (error) {
          throw error;
        }
      },

      getAllSubscriptionPlansForManagement: async () => {
        try {
          const response = await axios.get(`${API_URL}/SubscriptionPlan/GetAllSubscriptionPlansForManagement`);
          return unwrapList(response.data);
        } catch (error) {
          throw error;
        }
      },

      createSubscriptionPlan: async (payload) => {
        try {
          const response = await axios.post(`${API_URL}/SubscriptionPlan/CreateSubscriptionPlan`, payload);
          return response.data;
        } catch (error) {
          throw error;
        }
      },

      updateSubscriptionPlan: async (id, payload) => {
        try {
          const response = await axios.put(
            `${API_URL}/SubscriptionPlan/UpdateSubscriptionPlan/${id}`,
            { ...payload, id }
          );
          return response.data;
        } catch (error) {
          throw error;
        }
      },

      reactivateSubscriptionPlan: async (id) => {
        try {
          const response = await axios.post(`${API_URL}/SubscriptionPlan/ReactivateSubscriptionPlan/${id}`);
          return response.data;
        } catch (error) {
          throw error;
        }
      },

      deleteSubscriptionPlan: async (id) => {
        try {
          await axios.delete(`${API_URL}/SubscriptionPlan/DeleteSubscriptionPlan/${id}`);
        } catch (error) {
          throw error;
        }
      },

};
export default SubscriptionService;